module.exports = __webpack_public_path__ + "media/images/favicon100x100-f72f12e9707093f8ff320038bfc843a7.png";